import { render, staticRenderFns } from "./Fly.vue?vue&type=template&id=2c92931e&"
import script from "./Fly.vue?vue&type=script&lang=js&"
export * from "./Fly.vue?vue&type=script&lang=js&"
import style0 from "./Fly.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports